export default __webpack_public_path__ + "static/media/admin-dashboard-trailers.391f6969.png";